import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FolderContext } from '@app/shared/types/models/files/explorer-folder.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { FolderDTO } from '../dtos/folders/folder.dto';

@Injectable({ providedIn: 'root' })
export class FolderHttpService {
  private readonly http = inject(HttpClient);

  public getRoot(context: FolderContext): Observable<FolderDTO | null> {
    const segments: Record<FolderContext['kind'], string> = {
      company: 'companies',
      project: 'projects',
      task: 'tasks'
    };
    return this.http.get<FolderDTO | null>(
      `${environment.APIV3EndPoint}${segments[context.kind]}/${encodeURIComponent(context.id)}/folders`
    );
  }

  public setExternalLink(folderId: string, url: string | null): Observable<FolderDTO> {
    return this.http.put<FolderDTO>(
      `${environment.APIV3EndPoint}folders/${encodeURIComponent(folderId)}/external-link`,
      { url }
    );
  }

  public initialize(context: FolderContext): Observable<FolderDTO> {
    const segments = { company: 'companies', project: 'projects', task: 'tasks' };
    return this.http.post<FolderDTO>(
      `${environment.APIV3EndPoint}${segments[context.kind]}/${encodeURIComponent(context.id)}/folders/initialize`,
      {}
    );
  }

  public create(parentFolderId: string, name: string): Observable<FolderDTO> {
    return this.http.post<FolderDTO>(`${environment.APIV3EndPoint}folders`, { parentFolderId, name });
  }

  public rename(folderId: string, name: string): Observable<FolderDTO> {
    return this.http.put<FolderDTO>(
      `${environment.APIV3EndPoint}folders/${encodeURIComponent(folderId)}`,
      JSON.stringify(name),
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  public delete(folderId: string): Observable<void> {
    return this.http.delete<void>(`${environment.APIV3EndPoint}folders/${encodeURIComponent(folderId)}`);
  }

  public getById(folderId: string): Observable<FolderDTO> {
    return this.http.get<FolderDTO>(`${environment.APIV3EndPoint}folders/${encodeURIComponent(folderId)}`);
  }
}
